import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=5ca732da&"
import script from "./RuleTable.vue?vue&type=script&lang=ts&"
export * from "./RuleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports